<template>
  <div class="payment-notification">
    <div class="payment-notification__overlay"></div>
    <div class="payment-notification__body">
      <div class="payment-notification__title">
        <span>Payment is&nbsp;unsuccessful</span>
      </div>
      <div class="payment-notification__content">
        <div class="payment-notification__medium-text">
          <span>
            We&nbsp;have received a&nbsp;refusal notice from your bank <span v-if="chargeIsFailedSecondTime">again</span>
          </span>
        </div>
        <div
          class="payment-notification__small-text"
          :class="{
            'payment-notification__small-text_failure-payment': paymentIsUnsuccess
          }"
        >
          <span v-if="paymentIsUnsuccess">
            Changing the subscription plan has been cancelled.
          </span>
          <span v-else-if="chargeIsFailedFirstTime || chargeIsFailedSecondTime">
            The regular payment plan has been cancelled. We&nbsp;will attempt to&nbsp;get payment again on&nbsp; {{nextPaymentDate | format(dateFormat) }}. You can still use your current plan.
          </span>
        </div>
        <div class="payment-notification__drone"></div>
        <button-el :disabled="inProgress" @click="dismiss(userNotificationKey)" class="btn-dismiss">Understand</button-el>
        <button-el
          red
          v-if="!isSubscriptionPage"
          :disabled="inProgress"
          class="btn-subscription"
          @click="clickSubscriptionsBtn(userNotificationKey)"
        >Subscriptions</button-el>
        <round-btn small @click="dismiss(userNotificationKey)" class="btn btn_got-it_round ">
          <icon-base red :disabled="inProgress">
            <icon-check />
          </icon-base>
        </round-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { dateFormat } from 'src/utils/config';
import { IconCheck } from 'Icons';
import NotificationsKeys from 'src/models/NotificationsKeys';
import userNotitficationsMixin from './userNotitficationsMixin';

export default {
  mixins: [
    userNotitficationsMixin,
  ],
  data: () => ({
    NotificationsKeys,
  }),
  props: {
    paymentIsUnsuccess: Boolean,
    nextPaymentDate: String,
    chargeIsFailedFirstTime: Boolean,
    chargeIsFailedSecondTime: Boolean,
  },
  filters: {
    format,
  },
  components: {
    IconCheck,
  },
  computed: {
    isSubscriptionPage() {
      return this.$route.meta.isSubscriptionManagement;
    },
    userNotificationKey() {
      if (this.chargeIsFailedFirstTime) {
        return NotificationsKeys.chargeIsFailedFirstTime;
      } else if (this.chargeIsFailedSecondTime) {
        return NotificationsKeys.chargeIsFailedSecondTime;
      }
      return NotificationsKeys.paymentIsUnsuccess;
    },
    dateFormat: () => dateFormat,
  },
};
</script>

<style lang="scss" scoped>
$max-width: 380px;
.payment-notification {
  display: flex;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10000;
  justify-content: center;
  align-items: center;
  &__content {
    overflow-x: hidden;
    position: relative;
  }
  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: $black-color5;
  }
  &__body {
    max-width: $max-width;
    width: 100%;
    min-height: 339px;
    margin: auto $modal-side-margin;
    background: $white-color2;
    position: relative;
    z-index: 10001;
  }
  &__title {
    @include font(24px, $black-color1, 500);
    border-bottom: 1px solid $white-color5;
    padding: 26px 29px 27px;
  }
  &__medium-text {
    max-width: 250px;
    @include font(16px, $black-color1, 500);
    line-height: 22px;
  }
  &__small-text {
    @include font(13px, $black-color1);
    line-height: 21px;
    margin-top: 7px;
    max-width: 215px;
    margin-bottom: 24px;
    &_failure-payment {
      margin-bottom: 67px;
    }
  }
  &__content {
    padding: 29px 30px;
  }
  &__drone {
    @include attachImage('drone-confused', 81px, 125px);
    position: absolute;
    right: 29px;
    top: 30px;
  }
}
.btn-subscription {
  margin-left: 16px;
}
.btn_got-it_round {
  @include incrSelectorWeight(1) {
    display: none;
  }
}

$bp: $max-width + ($modal-side-margin * 2) - 1px;
@media screen and (max-width: $bp) {
  .btn-dismiss {
    display: none;
  }
  .payment-notification__drone {
    right: -26px;
  }
  .payment-notification__wrap {
    width: 100vw;
    max-width: calc(100vw - #{$modal-side-margin * 2});
  }
  .btn_got-it_round {
    @include incrSelectorWeight(1) {
      display: inline-flex;
      margin-left: 30px;
      vertical-align: middle;
    }
  }
  .btn-subscription {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userNotifications/UnsuccessPayment.vue